function DateStringCellTemplate({ child, returnMessage }) {
    return child?.dob ? new Date(child.dob).toLocaleDateString() : returnMessage;
}

export default DateStringCellTemplate;
